<div class="text-center">
    <h1>Pagina non trovata</h1>
    <p>La pagina che stai cercando non esiste. Controlla l'URL o torna alla pagina principale.</p>
    <button type="button" class="btn btn-secondary" (click)="goHome()">Torna alla Home</button>
</div>